import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const TimerComponent = ({
  initialTime = { day: 0, hour: 0, minute: 0, second: 0 },
}) => {
  const [remainingTime, setRemainingTime] = useState(initialTime);
  console.log(remainingTime);
  const { t } = useTranslation();

  useEffect(() => {
    // Function to decrement the timer
    const decrementTime = () => {
      setRemainingTime((prevTime) => {
        let { day, hour, minute, second } = prevTime;

        if (second > 0) {
          second -= 1;
        } else {
          if (minute > 0) {
            minute -= 1;
            second = 59; // Reset seconds to 59
          } else {
            if (hour > 0) {
              hour -= 1;
              minute = 59; // Reset minutes to 59
              second = 59; // Reset seconds to 59
            } else {
              if (day > 0) {
                day -= 1;
                hour = 23; // Reset hours to 23
                minute = 59; // Reset minutes to 59
                second = 59; // Reset seconds to 59
              }
            }
          }
        }

        // If all time is zero, stop the timer
        if (day === 0 && hour === 0 && minute === 0 && second === 0) {
          clearInterval(interval);
        }

        return { day, hour, minute, second };
      });
    };

    const interval = setInterval(decrementTime, 1000); // Update every second

    return () => {
      clearInterval(interval); // Clean up the interval on unmount
    };
  }, []);

  const renderTimer = () => {
    return (
      <div className="relative w-full mx-auto">
        <div className="flex flex-row gap-2 mx-auto relative     w-[96%]  px-2 z-20 justify-around   h-auto rounded-full">
          <div className="flex flex-col justify-center items-center">
            {" "}
            <div className="cp-timer-item relative   pt-[2px]">
              <div className="flex flex-row gap-2 justify-center">
                <span className="text-[#fff]  font-inter relative  text-center font-semibold text-[22px] leading-[69.31px] tracking-normal  w-[48px] h-[43px] rounded-[5px]">
                  {remainingTime.day}
                </span>
              </div>
            </div>
            <p className="  text-[#fff] text-base  font-bold leading-[48.32px] text-center">
              {t("Days")}
            </p>
          </div>
          <div className="flex flex-col justify-center items-center">
            <div className="cp-timer-item relative   pt-[2px]">
              <div className="flex flex-row gap-2   justify-center">
                <span className="text-[#fff]  font-inter relative  text-center font-semibold text-[22px] leading-[69.31px] tracking-normal  w-[48px] h-[43px] rounded-[5px]">
                  {remainingTime.hour}
                </span>
              </div>
            </div>
            <p className="  text-[#fff] text-base  font-bold leading-[48.32px] text-center">
              {t("Hours")}
            </p>
          </div>
          <div className="flex flex-col justify-center items-center">
            <div className="cp-timer-item relative  pt-[2px]">
              <div className="flex flex-row gap-2 justify-center">
                <span className="text-[#fff]  font-inter relative  text-center font-semibold text-[22px] leading-[69.31px] tracking-normal  w-[48px] h-[43px] rounded-[5px]">
                  {remainingTime.minute}
                </span>
              </div>
            </div>
            <p className="  text-[#fff] text-base  font-bold leading-[48.32px] text-center">
              {t("Mintues")}
            </p>
          </div>
          <div className="flex flex-col justify-center items-center">
            <div className="cp-timer-item relative  pt-[2px]">
              <div className="flex flex-row gap-2 justify-center">
                <span className="text-[#fff] text-center relative  font-inter font-semibold text-[22px] leading-[69.31px] tracking-normal  w-[48px] h-[43px] rounded-[5px]">
                  {remainingTime.second}
                </span>
              </div>
            </div>
            <p className="  text-[#fff] text-base  font-bold leading-[48.32px] text-center">
              {t("Seconds")}
            </p>
          </div>
        </div>
      </div>
    );
  };

  return renderTimer();
};

export default TimerComponent;
